import Korony from "./korony";

const BASE_WIDTH = 1200;
const BASE_HEIGHT = 600;

export type GameConfig = {
    container: HTMLElement
}

export default function createGame(config: GameConfig) {

    const app = new Korony(BASE_WIDTH, BASE_HEIGHT, 0xfff8e6, config)

    config.container.appendChild(app.view);
    app.gameResize();

    // ====================== //

    return {
        getSceenBlob: () => app.getSceenBlob(),
        uninstall: () => {
            app.destroy();
        }
    };
}
